import script from "./SfxTableBottom.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxTableBottom.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPagination,QIcon});
